import CardInfoBlock, { CardInfoBlockProps } from './CardInfoBlock';
import withInteractor from './CardInfoBlock.interactor';
import withPresenter from './CardInfoBlock.presenter';

export type { CardInfoBlockProps };
export default withInteractor(withPresenter(CardInfoBlock));
